import React, { useCallback, useEffect, useState } from "react";
import api, { isApprover, isAccountant } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Lock } from "lucide-react";

// Returns "" for admins (and accountants when accountantOk), the typed reason for others, or null when cancelled / left empty.
export const askReason = (user, action, what, accountantOk = false) => {
  if (isApprover(user) || (accountantOk && isAccountant(user))) return "";
  const r = window.prompt(`Reason for ${action} of ${what} (admin will see this before approving):`, "");
  if (r === null) return null;
  if (!r.trim()) { window.alert("A reason is required."); return null; }
  return r.trim();
};

export const useApprovalLocks = () => {
  const [locks, setLocks] = useState({});
  const reload = useCallback(() => {
    api.get("/approval-locks").then((r) => setLocks(r.data || {})).catch(() => setLocks({}));
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return [locks, reload];
};

export const LockBadge = ({ info, onClick, testid }) => (
  <button data-testid={testid} onClick={onClick} title="Waiting for admin approval"
    className="inline-flex items-center gap-1 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded bg-accent/15 text-accent hover:bg-accent/25 transition-colors">
    <Lock size={10} /> {info.action === "edit" ? "Edit pending" : "Delete pending"}
  </button>
);

export const LockNotice = ({ info, onClose }) => (
  <Dialog open={!!info} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent data-testid="lock-notice" className="max-w-md">
      <DialogHeader><DialogTitle className="font-display text-2xl flex items-center gap-2"><Lock size={18} /> Locked — awaiting approval</DialogTitle></DialogHeader>
      {info && (
        <div className="space-y-2 text-sm">
          <div><span className="text-muted-foreground">Entry:</span> <b>{info.label}</b></div>
          <div><span className="text-muted-foreground">Request:</span> {info.action === "edit" ? "Edit" : "Delete"} by {info.requested_by_name || "user"} on {(info.created_at || "").slice(0, 16).replace("T", " ")}</div>
          <div data-testid="lock-notice-reason" className="rounded-md bg-muted p-3"><span className="text-muted-foreground">Reason:</span> {info.reason || "—"}</div>
          <div className="text-xs text-muted-foreground">This entry can't be changed until an admin approves or rejects the request on the Approvals page.</div>
        </div>
      )}
      <DialogFooter>
        <button data-testid="lock-notice-close" onClick={onClose} className="h-10 px-4 rounded-md bg-primary text-primary-foreground text-sm">Close</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
